var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlusPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6728FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.051 16.4c.146 0 .278-.034.395-.105.118-.07.213-.162.286-.277.073-.114.11-.241.11-.382V9.791h5.678c.14 0 .27-.035.39-.105.121-.07.216-.166.286-.286.07-.12.106-.253.106-.4 0-.14-.035-.27-.106-.39-.07-.12-.165-.216-.285-.286-.12-.07-.25-.106-.391-.106H9.842V2.365c0-.141-.037-.27-.11-.387-.073-.117-.168-.21-.286-.277-.117-.067-.249-.101-.395-.101-.14 0-.271.034-.391.101s-.215.16-.286.277c-.07.117-.105.246-.105.387v5.853H2.582c-.14 0-.27.035-.386.106-.118.07-.213.165-.286.285-.073.12-.11.25-.11.391 0 .147.037.28.11.4.073.12.168.216.286.286.117.07.246.105.386.105H8.27v5.845c0 .14.035.268.105.382.07.115.166.207.286.277.12.07.25.106.391.106z",
    transform: "translate(-113 -778) translate(16 763) translate(97.5 15)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusPurple);
export default __webpack_public_path__ + "static/media/ic_plus_purple.48cb0c2e4b17c0b05a90a03028d4a251.svg";
export { ForwardRef as ReactComponent };